import { useNavigate } from 'react-router-dom';

function BackButton({ fallbackTo = '/', label = 'Back' }) {
  const navigate = useNavigate();

  const handleBack = () => {
    // If there's a history stack, go back; otherwise fallback to a safe route.
    if (typeof window !== 'undefined' && window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallbackTo);
    }
  };

  return (
    <button type="button" className="header-outline-button" onClick={handleBack}>
      ← {label}
    </button>
  );
}

export default BackButton;















